import React, { useState } from "react";
import "../Styles/Addmember.css";
import { RiCloseLargeFill } from "react-icons/ri";
import { toast } from "react-toastify";
import ApiService from "../nhrc_apis/ApiService";

function Addmember({ show = true, onClose = () => {} }) {
  const [formData, setFormData] = useState({
    full_name:          "",
    professional_title: "",
    current_position:   "",
    linkedin_url:       "",
    twitter_url:        "",
    facebook_url:       "",
  });
  const [photoFile, setPhotoFile]       = useState(null);
  const [photoPreview, setPhotoPreview] = useState("");
  const [loading, setLoading]           = useState(false);

  // ─── GET MEMBERSHIP ID FROM TOKEN ────────────────────
  const getMembershipId = () => {
    const token =
      localStorage.getItem("adminToken") ||
      localStorage.getItem("token");
    if (!token) return "ADMIN001";
    try {
      const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
      const decoded = JSON.parse(window.atob(base64));
      return decoded?.membership_id || "ADMIN001";
    } catch {
      return "ADMIN001";
    }
  };

  // ─── HANDLE TEXT INPUTS ───────────────────────────────
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // ─── HANDLE PHOTO FILE ────────────────────────────────
  const handlePhotoChange = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    setPhotoFile(file);
    setPhotoPreview(URL.createObjectURL(file));
  };

  // ─── SUBMIT ───────────────────────────────────────────
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.full_name.trim())          { toast.error("Full name cannot be empty!");          return; }
    if (!formData.professional_title.trim()) { toast.error("Professional title cannot be empty!"); return; }
    if (!formData.current_position.trim())   { toast.error("Current position cannot be empty!");   return; }
    if (!photoFile)                          { toast.error("Please upload a photo!");               return; }

    try {
      setLoading(true);

      // ─── STEP 1: Upload photo ──────────────────────────
      let photo_url = "";
      try {
        const imageFormData = new FormData();
        imageFormData.append("file",          photoFile);
        imageFormData.append("membership_id", getMembershipId());
        imageFormData.append("file_type",     "board_member");

        console.log("UPLOADING FILE:", photoFile.name, photoFile.type, photoFile.size);
        console.log("MEMBERSHIP ID:", getMembershipId());

        const uploadResponse = await ApiService.UploadAPI.uploadFile(imageFormData);
        console.log("UPLOAD RESPONSE DATA:", uploadResponse.data);

        photo_url =
          uploadResponse.data?.url        ||
          uploadResponse.data?.file_url   ||
          uploadResponse.data?.image_url  ||
          uploadResponse.data?.photo_url  ||
          uploadResponse.data?.path       ||
          uploadResponse.data?.filepath   ||
          uploadResponse.data?.file_path  ||
          "";

        console.log("EXTRACTED PHOTO URL:", photo_url);

        if (!photo_url) {
          toast.error("Upload succeeded but URL not found — check console!");
          setLoading(false);
          return;
        }

      } catch (uploadErr) {
        console.error("UPLOAD ERROR STATUS:", uploadErr?.response?.status);
        console.error("UPLOAD ERROR DATA:",   uploadErr?.response?.data);
        console.error("UPLOAD ERROR DETAIL:", JSON.stringify(uploadErr?.response?.data?.detail, null, 2));

        const detail = uploadErr?.response?.data?.detail;
        let errMsg = "Failed to upload photo!";
        if (Array.isArray(detail))            errMsg = detail.map((d) => d.msg || d.type).join(", ");
        else if (typeof detail === "string")  errMsg = detail;

        toast.error(errMsg);
        setLoading(false);
        return;
      }

      // ─── STEP 2: Create board member ──────────────────
      const payload = {
        full_name:          formData.full_name.trim(),
        professional_title: formData.professional_title.trim(),
        current_position:   formData.current_position.trim(),
        photo_url:          photo_url,
        linkedin_url:       formData.linkedin_url.trim(),
        twitter_url:        formData.twitter_url.trim(),
        facebook_url:       formData.facebook_url.trim(),
      };

      console.log("CREATE PAYLOAD:", payload);

      const response = await ApiService.BoardMembersAPI.createBoardMember(payload);
      console.log("CREATE RESPONSE:", response.data);

      toast.success("Board Member Added Successfully!");

      // ─── RESET ────────────────────────────────────────
      setFormData({
        full_name:          "",
        professional_title: "",
        current_position:   "",
        linkedin_url:       "",
        twitter_url:        "",
        facebook_url:       "",
      });
      setPhotoFile(null);
      setPhotoPreview("");

      onClose();

    } catch (err) {
      console.error("CREATE BOARD MEMBER ERROR:", err?.response?.data);
      const detail = err?.response?.data?.detail;
      let msg = "Failed to add member. Try again!";
      if (Array.isArray(detail))                 msg = detail.map((d) => d.msg).join(", ");
      else if (typeof detail === "string")        msg = detail;
      else if (err?.response?.data?.message)      msg = err.response.data.message;
      toast.error(msg);
    } finally {
      setLoading(false);
    }
  };

  if (!show) return null;

  return (
    <div className="addmember-modal">
      <div className="addmember-card">

        <button className="close-arrow" onClick={() => onClose()}>
          <RiCloseLargeFill />
        </button>

        <h4 className="addmemberpage-title text-center">Add Board Member</h4>

        <form className="addmember-form row g-3 p-3" onSubmit={handleSubmit}>

          {/* Full Name */}
          <div className="col-md-12">
            <label className="add-form-label">
              Full Name <span className="add-text-danger">*</span>
            </label>
            <input
              type="text"
              name="full_name"
              className="add-form-control"
              placeholder="Enter Full Name"
              value={formData.full_name}
              onChange={handleChange}
            />
          </div>

          {/* Professional Title */}
          <div className="col-md-12">
            <label className="add-form-label">
              Professional Title <span className="add-text-danger">*</span>
            </label>
            <input
              type="text"
              name="professional_title"
              className="add-form-control"
              placeholder="Enter Professional Title"
              value={formData.professional_title}
              onChange={handleChange}
            />
          </div>

          {/* Current Position */}
          <div className="col-md-12">
            <label className="add-form-label">
              Current Position <span className="add-text-danger">*</span>
            </label>
            <input
              type="text"
              name="current_position"
              className="add-form-control"
              placeholder="Enter Current Position"
              value={formData.current_position}
              onChange={handleChange}
            />
          </div>

          {/* Upload Photo */}
          <div className="col-md-12">
            <label className="add-form-label">
              Upload Photo <span className="add-text-danger">*</span>
            </label>
            <input
              type="file"
              name="uploadPhoto"
              className="add-form-control"
              accept="image/*"
              onChange={handlePhotoChange}
            />
            {photoPreview && (
              <img
                src={photoPreview}
                alt="preview"
                style={{
                  width:        "80px",
                  height:       "80px",
                  borderRadius: "50%",
                  objectFit:    "cover",
                  marginTop:    "10px",
                  border:       "2px solid #ddd",
                }}
              />
            )}
          </div>

          {/* LinkedIn URL */}
          <div className="col-md-12">
            <label className="add-form-label">LinkedIn URL</label>
            <input
              type="text"
              name="linkedin_url"
              className="add-form-control"
              placeholder="https://linkedin.com/in/..."
              value={formData.linkedin_url}
              onChange={handleChange}
            />
          </div>

          {/* Twitter URL */}
          <div className="col-md-12">
            <label className="add-form-label">Twitter URL</label>
            <input
              type="text"
              name="twitter_url"
              className="add-form-control"
              placeholder="https://twitter.com/..."
              value={formData.twitter_url}
              onChange={handleChange}
            />
          </div>

          {/* Facebook URL */}
          <div className="col-md-12">
            <label className="add-form-label">Facebook URL</label>
            <input
              type="text"
              name="facebook_url"
              className="add-form-control"
              placeholder="https://facebook.com/..."
              value={formData.facebook_url}
              onChange={handleChange}
            />
          </div>

          {/* Submit */}
          <div className="col-12 text-center mt-4">
            <button
              type="submit"
              className="btn addmemberpage-btn px-5 fw-bold"
              disabled={loading}
            >
              {loading ? "Submitting..." : "Submit"}
            </button>
          </div>

        </form>
      </div>
    </div>
  );
}

export default Addmember;